import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { body1SemiBoldStyles, body2RegularStyles } from "shared";

const useSharedContainerStyle = () => {
    const { gray700 } = colors;

    return css({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flex: "1",
        padding: "16px 24px",

        "& > svg": {
            fontSize: "120px",
            marginBottom: "16px"
        },

        "& > div": {
            maxWidth: "311px",

            "& > div:first-of-type": {
                ...body1SemiBoldStyles,
                textAlign: "center",
                marginBottom: "8px"
            },

            "& > div:last-of-type": {
                ...body2RegularStyles,
                color: gray700,
                textAlign: "center"
            }
        },

        "& > button": {
            marginTop: "12px"
        }
    });
};

export { useSharedContainerStyle };
